// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemQuantity-module__wrapper___Sjr6y","label":"ItemQuantity-module__label___3cmhE"};